/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reconcile_Toast_Ignore_SuccessInputs */

const vi_reconcile_toast_ignore_success = /** @type {(inputs: Reconcile_Toast_Ignore_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã bỏ qua khoản CK`)
};

/**

* @param {Reconcile_Toast_Ignore_SuccessInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const reconcile_toast_ignore_success = /** @type {((inputs?: Reconcile_Toast_Ignore_SuccessInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reconcile_Toast_Ignore_SuccessInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_reconcile_toast_ignore_success(inputs)
});